import React from 'react';
import { useTranslation } from '../i18n';
import './LoadingSpinner.css';

export interface LoadingSpinnerProps {
  /** Loading mesajı */
  message?: string;
  /** Spinner boyutu */
  size?: 'small' | 'medium' | 'large';
  /** Spinner rengi */
  color?: 'primary' | 'secondary' | 'white';
  /** Tam sayfa loading mi? */
  fullPage?: boolean;
  /** Container sınıfı */
  className?: string;
  /** Inline stili */
  style?: React.CSSProperties;
  /** Loading mesajını gizle */
  hideMessage?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message,
  size = 'medium',
  color = 'primary',
  fullPage = false,
  className = '',
  style,
  hideMessage = false,
}) => {
  const { t } = useTranslation();
  const spinnerClasses = [
    'loading-spinner',
    `loading-spinner--${size}`,
    `loading-spinner--${color}`,
    className
  ].filter(Boolean).join(' ');

  const containerClasses = [
    'loading-container',
    fullPage ? 'loading-container--fullpage' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} style={style}>
      <div className={spinnerClasses}></div>
      {!hideMessage && message && (
  <p className="loading-message">{message || t('common.loading')}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
